import AgentAssistSvg from "@convin/components/svg/AgentAssistSvg";
import DownloadSvg from "@convin/components/svg/Dashboard/DownloadSvg";
import { useGetDownloadOptionsQuery } from "@convin/redux/services/settings/users.service";
import { isDefined } from "@convin/utils/helper/common.helper";
import { alpha, Box, Divider, Stack, Typography } from "@mui/material";
import CustomSkeletonLoader from "@convin/components/custom_components/Skeleton";

export default function LiveAssistLinks() {
    const { data: downloadOptions, isLoading } = useGetDownloadOptionsQuery();

    const platform = navigator.userAgent.toLowerCase();
    const os = platform.includes("mac")
        ? "mac"
        : platform.includes("windows")
        ? "windows"
        : platform.includes("linux")
        ? "linux"
        : null;

    const handleDownload = () => {
        const agentAssistEl = window.document.createElement("a");
        agentAssistEl.style.display = "none";

        agentAssistEl.download = "Agent Assist App";
        if (downloadOptions && os) {
            agentAssistEl.href = downloadOptions[os]?.link;
        }
        document.body.appendChild(agentAssistEl);
        agentAssistEl.click();
        document.body.removeChild(agentAssistEl);
        agentAssistEl.remove();
    };

    if (isLoading) {
        return <CustomSkeletonLoader rows={1} />;
    }

    return (
        <>
            {!!downloadOptions && isDefined(os) && (
                <>
                    <Stack
                        direction="row"
                        className="justify-between cursor-pointer"
                        onClick={handleDownload}
                        sx={{
                            "&:hover": {
                                bgcolor: (theme) =>
                                    alpha(theme.palette.primary.main, 0.1),
                            },
                        }}
                    >
                        <Box className="flex gap-4 justify-between items-center">
                            <AgentAssistSvg />
                            <Typography variant="body2">
                                Download Live Assist
                            </Typography>
                        </Box>
                        <DownloadSvg />
                    </Stack>
                    <Divider sx={{ my: 1.5, width: "100%" }} />
                </>
            )}
        </>
    );
}
